import React, { useContext, useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  AiFillCaretDown,
  AiFillHome,
  AiFillSetting,
  AiFillCloseCircle,
} from "react-icons/ai";
import { MdManageAccounts } from "react-icons/md";
import { FaFirstAid } from "react-icons/fa";
import {
  BiSolidReport,
  BiHelpCircle,
  BiUser,
  BiDollar,
  BiLogoVisa,
  BiBook,
  BiBuildingHouse,
} from "react-icons/bi";
import { LoginContext, SideNavContext } from "../../reactcontext/ReactContext";
import Logout from "../Logout";
import PermissionBasedNav from "./PermissionBasedNav";
import { LogoAndName } from "../";

const SideNavbar = () => {
  const [showDaysLinks, setShowDaysLinks] = useState(false);
  const [showMonthsLinks, setShowMonthsLinks] = useState(false);
  const [showPaymentLinks, setShowPaymentLinks] = useState(false);
  const { loginInfo } = useContext(LoginContext);
  const { setToggleMenu } = useContext(SideNavContext);
  const [toggleAdminTasks, setToggleAdminTasks] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();
  let pathKey = location.pathname.split("/").pop();
  const toggleAdminItems = () => setToggleAdminTasks((prev) => !prev);

  const devices = [
    { key: "profile", name: "Employee", icon: <BiUser fontSize={18} /> },
    {
      key: "visa_exp",
      name: "Visa Expire",
      icon: <BiLogoVisa fontSize={18} />,
    },
    { key: "30_days", name: "30 Days", icon: <BiLogoVisa fontSize={18} /> },
    { key: "60_days", name: "60 Days", icon: <BiLogoVisa fontSize={18} /> },
    { key: "90_days", name: "90 Days", icon: <BiLogoVisa fontSize={18} /> },
    { key: "expired", name: "Expired Visa", icon: <BiLogoVisa fontSize={18} /> },
    {
      key: "passport_exp",
      name: "Passport Expire",
      icon: <BiBook fontSize={18} />,
    },
    { key: "1_month", name: "1 Month", icon: <BiBook fontSize={18} /> },
    { key: "3_month", name: "3 Month", icon: <BiBook fontSize={18} /> },
    { key: "6_month", name: "6 Month", icon: <BiBook fontSize={18} /> },
    { key: "pass_expired", name: "Pass Expired", icon: <BiBook fontSize={18} /> },
    { key: "medical", name: "Medical", icon: <FaFirstAid fontSize={18} /> },
    { key: "agents", name: "Agents", icon: <BiBuildingHouse fontSize={18} /> },
    { key: "payments", name: "Payments", icon: <BiDollar fontSize={18} /> },
  ];

  const userNav = { key: "users", name: "Manage Users", icon: <MdManageAccounts fontSize={18} /> };

  const paymentSubMenus = [
    { key: "update", name: "Update Payment", icon: <BiDollar fontSize={18} /> },
    { key: "record", name: "Record Payment", icon: <BiDollar fontSize={18} /> },
    { key: "invoice", name: "Invoice", icon: <BiDollar fontSize={18} /> },
  ];
  const handleVisaClick = (key, name) => {
    if (key === "visa_exp" || key === "30_days" || key === "60_days" || key === "90_days" || key === "expired") {
      setShowDaysLinks(true);
      setShowMonthsLinks(false);
      setShowPaymentLinks(false);
    } else if (key === "passport_exp" || key === "1_month" || key === "3_month" || key === "6_month" || key==="pass_expired") {
      setShowDaysLinks(false);
      setShowMonthsLinks(true);
      setShowPaymentLinks(false);
    } else if (key === "payments") {
      setShowDaysLinks(false);
      setShowMonthsLinks(false);
      setShowPaymentLinks(!showPaymentLinks);
    } else {
      setShowDaysLinks(false);
      setShowMonthsLinks(false);
      setShowPaymentLinks(false);
    }
  };
  // console.log(activeNav, activeCategory);
  const linkActiveStyles =
    "opacity-90 text-[12pt] flex flex-row item-center gap-x-2 p-2";
  const linkNotActiveStyles =
    "opacity-60 text-[11pt] flex flex-row items-center gap-x-2";

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Adjust the threshold as needed
    };
    if (pathKey === "visa_exp" || pathKey === "30_days" || pathKey === "60_days" || pathKey === "90_days" || pathKey === "expired") {
      setShowDaysLinks(true);
      setShowMonthsLinks(false);
      setShowPaymentLinks(false);
    } else if (pathKey === "passport_exp" || pathKey === "1_month" || pathKey === "3_month" || pathKey === "6_month" || pathKey === "pass_expired") {
      setShowDaysLinks(false);
      setShowMonthsLinks(true);
      setShowPaymentLinks(false);
    } else if (pathKey === "payments" || pathKey === "update" || pathKey === "record" || pathKey === "history" || pathKey === "invoice" || pathKey === "visaExpire") {
      setShowDaysLinks(false);
      setShowMonthsLinks(false);
      setShowPaymentLinks(true);
    } else {
      setShowDaysLinks(false);
      setShowMonthsLinks(false);
      setShowPaymentLinks(false);
    }
    // Initial check on component mount
    handleResize();

    // Event listener for window resize
    window.addEventListener("resize", handleResize);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [pathKey]);

  return (
    <div
      onClick={() => {
        if (isMobile) {
          setToggleMenu(false);
        }
      }}
      className="min-w-[275px] h-full flex-col overflow-hidden bg-white md:flex p-2 pl-5 gap-y-2 md:relative absolute md:top-0 top-24 z-30"
    >
      <div className="md:flex hidden">
        <LogoAndName />
      </div>

      <div className="mt-5 flex flex-col gap-y-3">
        {/* Dashboard is now handled by PermissionBasedNav */}
      </div>

      <div className="mt-10 flex flex-col gap-y-3 overflow-y-auto">
        <PermissionBasedNav />
      </div>

      <div className="mt-7 flex flex-col gap-y-3">
        <Logout />
      </div>
    </div>
  );
};

export default SideNavbar;
